<template>
  <div class="card pointer">
    <div class="card-content" :class="visualizar_qrcode ? 'blur' : ''" @click="visualizar_qrcode = true">
      <div class="avatar">
        <span class="avatar-ini"><i class="fas fa-qrcode"></i></span>
      </div>
      <div class="info">
        <p class="nome">Visualizar QR Code</p>
        <span class="subtitulo">Visualize e faça download do QR Code.</span>
      </div>
    </div>

    <div class="card-back" :class="(visualizar_qrcode ? 'show' : '')">
      <template v-if="qrcode_key === ''">
        <p class="msg-erro">Nenhum QRcode foi gerado.</p>
      </template>
      <template v-else>
        <qrcode class="qrcode" :value="qrcode_key" :options="{ size: 120, }"></qrcode>
        <el-button @click="abrirDialog.aberto = true" icon="el-icon-download" class="download-qrcode botao ml-5">
          <span>Fazer Download do QR Code</span>
        </el-button>
      </template>
      <el-button @click.stop="visualizar_qrcode = false" icon="el-icon-close" class="fechar" size="mini" circle/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisualizarQRcode',
  props: {
    abrirDialog: {
      type: Object,
      required: true
    },
    qrcode_key: {
      type: String,
      required: true
    }
  },
  data: () => ({
    visualizar_qrcode: false
  })
};
</script>
